Array.prototype.filter || (Array.prototype.filter = function(a) {
	if (void 0 === this || null === this)
			throw new TypeError;
	var b = Object(this)
		, c = b.length >>> 0;
	if ("function" !== typeof a)
			throw new TypeError;
	for (var d = [], e = 2 <= arguments.length ? arguments[1] : void 0, f = 0; f < c; f++)
			if (f in b) {
					var g = b[f];
					a.call(e, g, f, b) && d.push(g)
			}
	return d
}
);
var uaInfo = {
	ua: "",
	is: function(a) {
			return RegExp(a, "i").test(uaInfo.ua)
	},
	version: function(a, b) {
			b = b.replace(".", "_");
			for (var c = b.indexOf("_"), d = ""; 0 < c; )
					d += " " + a + b.substring(0, c),
					c = b.indexOf("_", c + 1);
			return d + (" " + a + b)
	},
	getBrowser: function() {
			var a = uaInfo.ua
				, b = uaInfo.is;
			return [!/opera|webtv/i.test(a) && /msie\s(\d+)/.test(a) ? "ie ie" + (/trident\/4\.0/.test(a) ? "8" : RegExp.$1) : b("trident/") ? "ie ie" + (/trident\/.+rv:(\d+)/i.test(a) ? RegExp.$1 : "") : b("firefox/") ? "gecko firefox" + (/firefox\/((\d+)(\.(\d+))(\.\d+)*)/.test(a) ? " firefox" + RegExp.$2 + " firefox" + RegExp.$2 + "_" + RegExp.$4 : "") : b("gecko/") ? "gecko" : b("opera") ? "opera" + (/version\/((\d+)(\.(\d+))(\.\d+)*)/.test(a) ? " opera" + RegExp.$2 + " opera" + RegExp.$2 + "_" + RegExp.$4 : /opera(\s|\/)(\d+)\.(\d+)/.test(a) ? " opera" + RegExp.$2 + " opera" + RegExp.$2 + "_" + RegExp.$3 : "") : b("konqueror") ? "konqueror" : b("blackberry") ? "blackberry" + (/Version\/(\d+)(\.(\d+)+)/i.test(a) ? " blackberry" + RegExp.$1 + " blackberry" + RegExp.$1 + RegExp.$2.replace(".", "_") : /Blackberry ?(([0-9]+)([a-z]?))[\/|;]/gi.test(a) ? " blackberry" + RegExp.$2 + (RegExp.$3 ? " blackberry" + RegExp.$2 + RegExp.$3 : "") : "") : b("android") ? "android" + (/Version\/(\d+)(\.(\d+))+/i.test(a) ? " android" + RegExp.$1 + " android" + RegExp.$1 + RegExp.$2.replace(".", "_") : "") + (/Android (.+); (.+) Build/i.test(a) ? " device_" + RegExp.$2.replace(/ /g, "_").replace(/-/g, "_") : "") : b("chrome") ? "webkit chrome" + (/chrome\/((\d+)(\.(\d+))(\.\d+)*)/.test(a) ? " chrome" + RegExp.$2 + (0 < RegExp.$4 ? " chrome" + RegExp.$2 + "_" + RegExp.$4 : "") : "") : b("iron") ? "webkit iron" : b("applewebkit/") ? "webkit safari" + (/version\/((\d+)(\.(\d+))(\.\d+)*)/.test(a) ? " safari" + RegExp.$2 + " safari" + RegExp.$2 + RegExp.$3.replace(".", "_") : / Safari\/(\d+)/i.test(a) ? "419" == RegExp.$1 || "417" == RegExp.$1 || "416" == RegExp.$1 || "412" == RegExp.$1 ? " safari2_0" : "312" == RegExp.$1 ? " safari1_3" : "125" == RegExp.$1 ? " safari1_2" : "85" == RegExp.$1 ? " safari1_0" : "" : "") : b("mozilla/") ? "gecko" : ""]
	},
	getPlatform: function() {
			var a = uaInfo.ua
				, b = uaInfo.version
				, c = uaInfo.is;
			return [c("j2me") ? "j2me" : c("ipad|ipod|iphone") ? (/CPU( iPhone)? OS (\d+[_|\.]\d+([_|\.]\d+)*)/i.test(a) ? "ios" + b("ios", RegExp.$2) : "") + " " + (/(ip(ad|od|hone))/gi.test(a) ? RegExp.$1 : "") : c("playbook") ? "playbook" : c("kindle|silk") ? "kindle" : c("playbook") ? "playbook" : c("mac") ? "mac" + (/mac os x ((\d+)[.|_](\d+))/.test(a) ? " mac" + RegExp.$2 + " mac" + RegExp.$1.replace(".", "_") : "") : c("win") ? "win" + (c("windows nt 6.2") ? " win8" : c("windows nt 6.1") ? " win7" : c("windows nt 6.0") ? " vista" : c("windows nt 5.2") || c("windows nt 5.1") ? " win_xp" : c("windows nt 5.0") ? " win_2k" : c("windows nt 4.0") || c("WinNT4.0") ? " win_nt" : "") : c("freebsd") ? "freebsd" : c("x11|linux") ? "linux" : ""]
	},
	getMobile: function() {
			var a = uaInfo.is;
			return [a("android|mobi|mobile|j2me|iphone|ipod|ipad|blackberry|playbook|kindle|silk") ? "mobile" : ""]
	},
	getIpadApp: function() {
			var a = uaInfo.is;
			return [a("ipad|iphone|ipod") && !a("safari") ? "ipad_app" : ""]
	},
	getLang: function() {
			return [/[; |\[](([a-z]{2})(\-[a-z]{2})?)[)|;|\]]/i.test(uaInfo.ua) ? ("lang_" + RegExp.$2).replace("-", "_") + ("" != RegExp.$3 ? (" lang_" + RegExp.$1).replace("-", "_") : "") : ""]
	}
};
var html = document.documentElement;
var screenInfo = {
	width: (window.outerWidth || html.clientWidth) - 15,
	height: window.outerHeight || html.clientHeight,
	screens: [0, 768, 980, 1200],
	screenSize: function() {
			screenInfo.width = (window.outerWidth || html.clientWidth) - 15;
			screenInfo.height = window.outerHeight || html.clientHeight;
			for (var a = screenInfo.screens, b = a.length, c = []; b--; )
					if (screenInfo.width >= a[b]) {
							b && c.push("minw_" + a[b]);
							2 >= b && c.push("maxw_" + (a[b + 1] - 1));
							break
					}
			return c
	},
	getOrientation: function() {
			return screenInfo.width < screenInfo.height ? ["orientation_portrait"] : ["orientation_landscape"]
	},
	getInfo: function() {
			var a = []
				, a = a.concat(screenInfo.screenSize());
			return a = a.concat(screenInfo.getOrientation())
	},
	getPixelRatio: function() {
			var a = []
				, b = window.devicePixelRatio ? window.devicePixelRatio : 1;
			1 < b ? (a.push("retina_" + parseInt(b) + "x"),
			a.push("hidpi")) : a.push("no-hidpi");
			return a
	}
}
, dataUriInfo = {
	data: new Image,
	div: document.createElement("div"),
	isIeLessThan9: !1,
	getImg: function() {
			dataUriInfo.data.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
			dataUriInfo.div.innerHTML = "\x3c!--[if lt IE 9]><i></i><![endif]--\x3e";
			dataUriInfo.isIeLessThan9 = 1 == dataUriInfo.div.getElementsByTagName("i").length;
			return dataUriInfo.data
	},
	checkSupport: function() {
			return 1 != dataUriInfo.data.width || 1 != dataUriInfo.data.height || dataUriInfo.isIeLessThan9 ? ["no-datauri"] : ["datauri"]
	}
};
function css_browser_selector(a, b) {
	var c = document.documentElement
		, d = [];
	b = b ? b : "";
	var addEvent = window.attachEvent || window.addEventListener;
	var touchscreen = "ontouchstart"in window || window.DocumentTouch && document instanceof DocumentTouch ? "touch" : "no-touch";
	uaInfo.ua = a.toLowerCase();
	var d = d.concat(uaInfo.getBrowser())
		, d = d.concat(uaInfo.getPlatform())
		, d = d.concat(uaInfo.getMobile())
		, d = d.concat(uaInfo.getIpadApp())
		, d = d.concat(uaInfo.getLang())
		, d = d.concat(["js"])
		, d = d.concat([touchscreen])
		, d = d.concat(screenInfo.getPixelRatio())
		, d = d.concat(screenInfo.getInfo())
		, e = function() {
			c.className = c.className.replace(/ ?orientation_\w+/g, "").replace(/ [min|max|cl]+[w|h]_\d+/g, "");
			c.className = c.className + " " + screenInfo.getInfo().join(" ")
	};
	addEvent("resize", e);
	addEvent("orientationchange", e);
	e = dataUriInfo.getImg();
	e.onload = e.onerror = function() {
			c.className += " " + dataUriInfo.checkSupport().join(" ")
	}
	;
	d = d.filter(function(a) {
			return a
	});
	d[0] = b ? b + d[0] : d[0];
	c.className = d.join(" " + b);
	return c.className
}
var css_browser_selector_ns = css_browser_selector_ns || "";
css_browser_selector(navigator.userAgent, css_browser_selector_ns);
